import merge from 'lodash/merge';
import bluemed from './bluemed.json';
import anthem from './anthem.json';

/*
the brand names under allBrands object
and launchdarkly configs should match
*/
const allBrands = [
  { name: 'ANTHEM', config: anthem },
  { name: 'BLUEMED', config: bluemed },
];
Object.seal(allBrands);

export const getBrandConfigs = name => {
  let brandConfigToDispatch = anthem;
  if (name) {
    allBrands.forEach(brand => {
      if (name.toLowerCase() === brand.name.toLowerCase()) {
        brandConfigToDispatch = merge(anthem, brand.config);
      }
    });
  }
  return brandConfigToDispatch;
};
